"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const avatar_1 = require("primereact/avatar");
const button_1 = require("primereact/button");
const navbar_module_scss_1 = __importDefault(require("./navbar.module.scss"));
const api_1 = require("primereact/api");
const react_1 = require("react");
const tieredmenu_1 = require("primereact/tieredmenu");
const react_router_dom_1 = require("react-router-dom");
const AuthContext_1 = require("../../../hooks/auth/context/AuthContext");
const clearLocalStorage_1 = require("../../../common/utils/clearLocalStorage");
const NavBarComponent = ({ isSidebarVisible, toggleSidebar, children, subMenuItems, userName, }) => {
    const menu = (0, react_1.useRef)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const isInvoiceRoute = location.pathname.startsWith('/invoices');
    const { logout } = (0, AuthContext_1.useAuth)();
    const handleLogout = () => {
        // Limpia el localStorage
        (0, clearLocalStorage_1.clearLocalStorage)();
        logout();
    };
    const updatedSubMenuItems = subMenuItems?.map((item) => {
        if (item.label === 'logout') {
            return {
                ...item,
                command: handleLogout,
            };
        }
        return item;
    });
    return ((0, jsx_runtime_1.jsx)("div", { role: "navigation", className: `${isInvoiceRoute ? navbar_module_scss_1.default.navigationInvoice : navbar_module_scss_1.default.navigation} ${isSidebarVisible ? 'pl-[20rem]' : 'pl-4'}`, children: !isInvoiceRoute && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(button_1.Button, { className: navbar_module_scss_1.default.navbarButton, icon: api_1.PrimeIcons.ALIGN_JUSTIFY, onClick: toggleSidebar }), (0, jsx_runtime_1.jsxs)("div", { className: navbar_module_scss_1.default.avatarContainer, children: [(0, jsx_runtime_1.jsx)(tieredmenu_1.TieredMenu, { className: 'mt-3', model: updatedSubMenuItems, popup: true, ref: menu, breakpoint: "767px" }), (0, jsx_runtime_1.jsx)("span", { className: navbar_module_scss_1.default.userName, children: userName }), (0, jsx_runtime_1.jsx)(avatar_1.Avatar, { "data-testid": "avatar", icon: "pi pi-user", className: navbar_module_scss_1.default.avatar, size: "large", shape: "circle", onClick: (e) => menu.current?.toggle(e), "aria-label": "user", onImageError: (e) => {
                                ;
                                e.target.src = '';
                            } })] })] })) }));
};
exports.NavBarComponent = NavBarComponent;
